import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";


export async function searchRules(options, language, timeZone, cancelToken) {
  const { filters } = options;
  const {
    orderBy,
    orderDirection,
    id,
    page,
    name,
    type,
    resultsPerPage,
  } = filters;

  const params = {
    OrderBy: orderBy || "name",
    OrderDirection: orderDirection || "asc",
    Page: page || 1,
    ResultsPerPage: resultsPerPage || 15,
    Id: id || undefined,
    Name: name || undefined,
    Type: type || undefined,
  };

  try {
    const data = await wsRequestGet(
      "/admin/RelayRules/search",
      language,
      timeZone,
      params,
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to get rules: ${e}`);
    return {
      success: false,
    };
  }
}

export async function addRule(language, timeZone, cancelToken) {
  try {
    const data = await wsRequestPost(
      "/admin/RelayRules/create",
      language,
      timeZone,
      null,
      null,
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to create rule: ${e}`);
    return {
      success: false,
    };
  }
}

export async function getRuleById(ruleId, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/RelayRules/rule",
      language,
      timeZone,
      {ruleId},
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to get rule ${ruleId}: ${e}`);
    return {
      success: false,
    };
  }
}

export async function updateRule(rule, language, timeZone, cancelToken) {
  return await wsRequestPost(`/admin/RelayRules/update`, language, timeZone, rule, null, cancelToken);
}

export async function deleteRule(ruleId, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/RelayRules/delete",
      language,
      timeZone,
      {ruleId},
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to delete rule ${ruleId}: ${e}`);
    return {
      success: false,
    };
  }
}
